// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__T0ia8","authContainer":"layout_authContainer__Y09Iv"};